import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { CloseButton } from "../../SharedComponents/CloseButton/CloseButton";
import "./AdminRemoveUserFromAccountModal.css";

export const AdminRemoveUserFromAccountModal = ({ accept, reject, email }) => {
  const { t } = useTranslation();
  const modalRoot = document.querySelector("#modalroot");
  return createPortal(
    <div className="Modal__background">
      <div className="Modal__element">
        <div className="Modal__header">
          <div className="Modal__header-exit" onClick={reject}>
            <div className="Modal__header-exit-text">{t("generic.close")}</div>
            <CloseButton />
          </div>
          <div className="Modal__title">
            <div className="Modal__title-text">
              {t("users.revokeUserAccess")}
            </div>
          </div>
        </div>
        <div className="Modal__content">
          <div className="Modal__content-text">
            {`${t("users.revokeAcceptance")} ${email}?`}
          </div>
        </div>
        <div className="Modal__actions">
          <button
            className="Modal__actions-button Modal__actions-button--reject"
            onClick={reject}
          >
            {t("generic.cancel")}
          </button>
          <button
            className="Modal__actions-button Modal__actions-button--accept"
            style={{ backgroundColor: "#AA2525" }}
            onClick={accept}
          >
            {t("users.revokeAccess")}
          </button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};
